import React from 'react';
import { Button } from 'react-bootstrap';
import img from '../images/logo.png';
import StarRatingComponent from 'react-star-rating-component';
import { withRouter } from 'react-router-dom';
import Header from "./header";
import Logger from './Logger';
import noty from './Noty';
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
import checkForSession from "./SessionChecker";

class feedbackRating extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rating: 0,
            textarea: '',
            simTitle: '',
            createdBy: '',
            mainHub: props.hub,
            isSubmit: true
        };
        this.onFeedBackSubmit = this.onFeedBackSubmit.bind(this);
        this.feedbackOnChange = this.feedbackOnChange.bind(this);
        this.getSimulationUserFeedback = this.getSimulationUserFeedback.bind(this);
        this.backToHome = this.backToHome.bind(this);
    }

    componentDidMount() {
        this.props.history.location.state == undefined
            ?
            checkForSession(this.props)
            :
            this.getSimulationUserFeedback();
    }

    componentWillUnmount() {
        this.props.history.goForward();
    }

    setStates() {
        let props = this.props.location.state;
        this.setState({
            simTitle: props.title,
            created: props.createdBy,
        })
    }

    onStarClick(nextValue, prevValue, name) {
        this.setState({ rating: nextValue });
    }

    feedbackOnChange(e) {
        this.setState({ textarea: e.target.value });
    }

    onFeedBackSubmit() {
        var self = this;
        self.state.mainHub.invoke('SaveSimUserFeedback',
            self.props.location.state.token,
            self.state.textarea.trim(),
            self.state.rating
        )
            .then(function (response) {
                self.setState({
                    isSubmit: true
                })
            })
            .catch(function (error) {
                noty('error', 'Something went wrong.')
                Logger('Saving user feedback failed.', error.message, error.stack, 'Error');
            });
    }

    getSimulationUserFeedback() {
        var self = this;
        self.state.mainHub.invoke('GetSimulationUserFeedback',
            self.props.location.state.token
        )
            .then(function (response) {
                if (response != undefined) {
                    self.setState({
                        isSubmit: true
                    })
                } else {
                    self.setState({
                        isSubmit: false
                    })
                }
            })
            .catch(function (error) {
                noty('error', 'Something went wrong.')
                Logger('Getting simulation user feedback failed.', error.message, error.stack, 'Error');
            });
    }


    backToHome() {
        let path = "/";
        this.props.history.push({
            pathname: path
        });
    }
    render() {
        const { rating } = this.state;
        let state = this.props.location.state;
        if (state == undefined) {
            return null;
        }
        return (
            <div>
                <header>
                    <div className="top-header-block">
                        <Header data={state} showInput={false} />
                    </div>
                </header>
                <main>
                    <div className="mainBodyBlock">
                        <div className="clearfix feedbackBlock">
                            {this.state.isSubmit == false ?
                                (<div>
                                    <div className="feedbackCaptionText">Rate Your Feedback!</div>
                                    <div className="feedbackRatingStarts">
                                        <StarRatingComponent
                                            name="rate1"
                                            starCount={5}
                                            value={rating}
                                            onStarClick={this.onStarClick.bind(this)}
                                            starColor="rgb(92, 184, 92)"
                                            emptyStarColor="#adb5bd"
                                        />
                                    </div>
                                    <div className="feedbackTextArea"><textarea rows="3" onChange={this.feedbackOnChange} className="form-control feedbackComment" value={this.state.textarea} id="feedbackTxtArea" placeholder="Leave Comments..."></textarea></div>
                                    <div className="feedbackSubmitBlock"><Button type="button" className="btnStyle" onClick={this.onFeedBackSubmit}>Send Feedback</Button></div>
                                </div>)
                                :
                                <div>
                                    <div className="main-text">
                                        <span className="feedbackText">Thanks Your Feedback Has Been Added!</span>
                                    </div>
                                    <div className="main-body-heading-block clearfix">
                                        <div className="proceedTasksBlock float-right">
                                            <Button className="proceedTasks" color="success" onClick={this.backToHome}>Back To Home</Button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                    </div>


                </main>
                <footer>

                </footer>
            </div>
        );
    }
}
export default withRouter(feedbackRating);